import { z } from 'zod'
import { dateValueSchema } from './date-value'

/** 指派禮遇紀錄歷程 Schema */
export const recordListDataSchema = z.object({
  /** 指派者 */
  designee: z.string(),
  /** 指派日期 */
  assignTime: dateValueSchema,
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 收回禮遇者 */
  returner: z.string(),
  /** 收回禮遇日期 */
  returnTime: dateValueSchema
})

/** 指派禮遇紀錄歷程 */
export interface RecordListData extends z.infer<typeof recordListDataSchema> {}
